import React from 'react';
import { BusinessInfoContainer } from '../../../../../containers';

export const BusinessInfo = () => <BusinessInfoContainer />;
